// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1SekU","approved":"Status_approved__wH0_j","rejected":"Status_rejected__3qo7G","expired":"Status_expired__12W_Z","label":"Status_label__-2hRk"};